module.exports = __webpack_public_path__ + "img/tickets-sold-out.ba19cf2f.svg";